// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1efYu","footer":"styles_footer__3t6V0","passCodeTooltip":"styles_passCodeTooltip__VPbmx"};